export const ExcursionsRoutes = [{
  name: 'excursions',
  path: '/excursions',
  component: () => import(/* webpackChunkName: "ExcursionsModule" */ './Module')
}, {
  name: 'excursion',
  path: '/excursions/:slug',
  component: () => import(/* webpackChunkName: "ExcursionModule" */ './excursion/Module')
}];
